import { axios } from "../../../Config/axiosConfig";

const TERMO_API_URL = process.env.REACT_APP_TERMO_API_URL;

export const aceitarContrato = async () => {
  try {
    const { status, data } = axios.post(`${TERMO_API_URL}/salvarContratoAceito/5`)
    if (status === 200 && data.sucesso) {
      localStorage.setItem("_20ex20", true);
      return {
        status: true,
        message: "Contrato aceito com sucesso",
      };
    }
  } catch {
    return {
      status: false,
      message: "Aconteceu alguma falha ao aceitar o contrato",
    };
  }
};

export const getTermoUso = async () => {
  try {
    var response = await axios.get(`${TERMO_API_URL}/obtemTermoUso/5`, {
      responseType: "blob",
    });
    if (response.data) {
      var blob = new Blob([response.data], { type: "application/pdf" });
      var url = window.URL.createObjectURL(blob);
      return url;
    }
    return "";
  } catch (e) {
    console.error(e);
  }
};
